var r=function(r){return"l"===r?16:"s"===r?8:0};export{r as calcPadding};
